import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import SmartCityComponent from "../components/smart-city/smart-city.component"

const SmartCity = () => {
  return (
    <Layout>
      <SmartCityComponent />
    </Layout>
  )
}

export default SmartCity

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
